/* eslint-disable no-new */
import { Swiper, Navigation } from 'swiper/swiper.esm';

Swiper.use([Navigation]);

const config = {
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    preventClicks: false,
    preventClicksPropagation: false,
    slideToClickedSlide: false,
    observer: true,
    shortSwipes: false,
    freeMode: true,
    freeModeMomentumRatio: 0.3,
    slidesPerGroup: 4,
    speed: 500,
    spaceBetween: 10,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            spaceBetween: 15,
        },
        1024: {
            spaceBetween: 15,
        },
    },
};

const dayConfig = {
    ...config,
    spaceBetween: 10,
    slidesPerView: 4,
    breakpoints: {
        768: {
            slidesPerView: 5,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 7,
            spaceBetween: 15,
        },
    },
};

const FilterSwiper = () => {
    const dayFilter = new Swiper('.event-filter.day', dayConfig);

    const days = Array.from(document.querySelectorAll('.event-filter.day li'));
    days.forEach((day, i) => {
        const isActive = day.classList.contains('active');
        if (isActive) {
            dayFilter.slideTo(i, 0);
        }
    });

    const categoryFilter = new Swiper('.event-filter.category', config);

    const noVisibleCategory = categoryFilter.slides && categoryFilter.slides.length
        ? categoryFilter.slides.filter(
            s => !s.classList.contains('swiper-slide-visible'),
        )
        : [];
    if (
        categoryFilter.slides
        && categoryFilter.slides.length
        && !noVisibleCategory.length
    ) {
        categoryFilter.$el[0].classList.add('hide-nav');
    }

    const catgories = Array.from(
        document.querySelectorAll('.event-filter.category li'),
    );
    catgories.forEach((category, i) => {
        const isActive = category.classList.contains('active');
        if (isActive) {
            categoryFilter.slideTo(i, 0);
        }
    });
};

export default FilterSwiper;
